<nav class="navbar bg-body-tertiary shadow">
  <div class=" w-100 d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <a class="navbar-brand ms-5 " routerLink="/dashboard">
        <img src="assets/logo/avs.svg" alt="AVS-Portal Logo" height="35">
      </a>

      <div class="avs-nav-desktop nav-desktop">
        <a *canAccess="[1,5]" class="avs-nav-link mt-4 ms-4" routerLink='/dashboard' routerLinkActive="active"
          mat-button>Dashboard</a>

        <a class="avs-nav-link mt-4 ms-3" routerLink='/project' routerLinkActive="active" mat-button>Projekte</a>

        <a *canAccess="[1,5]" class="avs-nav-link mt-4 ms-3" routerLink="/device" routerLinkActive="active"
          mat-button>Geräte</a>

        <a *canAccess="[1,2,5,7,9]" class="avs-nav-link mt-4 ms-3" routerLink="/reporting" routerLinkActive="active"
          mat-button>Berichte</a>

        <a *canAccess="[1,2,5,7,9]" class="avs-nav-link mt-4 ms-3" routerLink="/error-engine" routerLinkActive="active"
          mat-button>
          Error Engine
        </a>

        <a *canAccess="[1,5]" class="avs-nav-link mt-4 ms-3" routerLink="/user" routerLinkActive="active"
          mat-button>Benutzerverwaltung</a>

        <a *canAccess="[1,5]" class="avs-nav-link mt-4 ms-3" routerLink="/company" routerLinkActive="active"
          mat-button>Firmenverwaltung</a>
      </div>

      <!-- Mobile Menu Trigger -->
      <button mat-icon-button class="nav-mobile-trigger avs-menu-toggle" [matMenuTriggerFor]="mobileMenu"
        aria-label="Menü">
          <img class="avs-menu-icon" src="assets/icons/list.svg" height="24"/>
      </button>
    </div>
    <!-- Status & User Section -->
    <div >
      <div class="navbar-status-container d-flex align-items-center">
        <!-- WebSocket Status -->
        <div class="status-icon avs-status-icon-wifi" [class.connected]="connectionStatus === 'connected'"
              [class.connecting]="connectionStatus === 'connecting'"
              [class.reconnecting]="connectionStatus === 'reconnecting'"
              [class.disconnected]="connectionStatus === 'disconnected'" [class.error]="connectionStatus === 'error'"
              [title]="getConnectionTitle()">
        </div>

        <!-- Alarm Status -->
        <div *ngIf="isAlarmAuthorized()" class="status-icon avs-status-alarm-icon" 
                [class.active]="areAlarmsActive()" [class.inactive]="!areAlarmsActive()"
                title="Alarm: {{areAlarmsActive() ? 'Aktiv' : 'Deaktiv'}}">
        </div>

        <!-- Akustische Alarme -->
        <div *ngIf="isAlarmAuthorized() && areAlarmsActive()" class="status-icon avs-status-alarm-icon" 
                [class.sound-on]="areAcousticAlarmsActive()" [class.sound-off]="!areAcousticAlarmsActive()"
                title="Ton: {{areAcousticAlarmsActive() ? 'Ein' : 'Aus'}}">
        </div>

        <!-- User Menu -->
        <button mat-icon-button [matMenuTriggerFor]="userMenu" class="avs-navbar-user">
          <img src="assets/icons/person-circle.svg" alt="Benutzerkonto" height="24">
        </button>
      </div>
    </div>
  </div>

  <!-- Mobile Menu -->
  <mat-menu #mobileMenu="matMenu" class="avs-mobile-menu ">
    <button mat-menu-item routerLink="/dashboard" *canAccess="[1,5]">Dashboard</button>
    <button mat-menu-item routerLink="/project">Projekte</button>
    <button mat-menu-item routerLink="/device" *canAccess="[1,5]">Geräte</button>
    <!--     <button mat-menu-item routerLink="/report" *canAccess="[1,2,5,7,9]">Berichte</button>
 --> <button mat-menu-item routerLink="/reporting" *canAccess="[1,2,5,7,9]">Berichte</button>
    <button mat-menu-item routerLink="/error-engine" *canAccess="[1]"> 
      <!--       <img src="assets/icons/contract.svg" alt="Error Engine" height="20" class="me-2">
 --> Error Engine
    </button> 
    <button mat-menu-item routerLink="/user" *canAccess="[1,5]">Benutzerverwaltung</button>
    <button mat-menu-item routerLink="/company" *canAccess="[1,5]">Firmenverwaltung</button>
  </mat-menu>

  <!-- User Dropdown Menu -->
  <mat-menu #userMenu="matMenu">
    <button mat-menu-item disabled>
      {{ user?.firstName }} {{ user?.lastName }}
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item routerLink="/user/user-data-settings">Benutzer Einstellungen</button>
    <button mat-menu-item (click)="logout()">Ausloggen</button>
  </mat-menu>

  <div class="container-fluid avs-underline-navbar"></div>
</nav>